import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { PayHistoryStateData } from './types';

const initialState: PayHistoryStateData = {
	data: {
		data: {
			count: '',
			current_page: '',
			has_next_page: '',
			has_previous_page: '',
			items: [],
			num_pages: '',
			error: '',
			login_error: '',
			message: '',
		},
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchPayHistory = createAsyncThunk(
	'api/fetchPayHistory',
	({ sessionId, fromDate, toDate, page }: { sessionId: string; fromDate: string; toDate: string; page: number }) =>
		api.fetchPayHistory(sessionId, fromDate, toDate, page),
);

const payHistorySlice = createSlice({
	name: 'payHistory',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchPayHistory.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchPayHistory.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchPayHistory.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			});
	},
});

export default payHistorySlice.reducer;
